import { MouseEvent, useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from '@cad-arc';
import { DISABLED_GOOGLE_MAPS_ROUTE_BUTTON_TOOLTIP_MESSAGE } from './constants';
import { useGoogleMapsRouteUrl } from './use-google-maps-route-url';
import { electronBridge } from '../../electron-bridge/electron-bridge';
import { Tooltip } from '~/common/components/tooltip';


export const GoogleMapsRouteButton = observer(function GoogleMapsRouteButton() {
    const googleMapsRouteUrl = useGoogleMapsRouteUrl();

    const openGoogleMapsRoute = useCallback(
        (clickEvent: MouseEvent) => {
            clickEvent.stopPropagation();

            if (googleMapsRouteUrl) {
                if (electronBridge) {
                    electronBridge.openUrlInBrowser(googleMapsRouteUrl);
                } else {
                    window.open(googleMapsRouteUrl);
                }
            }
        },
        [googleMapsRouteUrl]
    );

    const buttonContent = (
        <Button
            aria-label="Route"
            leadingVisual="Route"
            isDisabled={!googleMapsRouteUrl}
            onClick={openGoogleMapsRoute}
            data-testid="google-maps-route-button"
        >
            Route
        </Button>
    );

    if (!googleMapsRouteUrl) {
        return (
            <Tooltip overlay={DISABLED_GOOGLE_MAPS_ROUTE_BUTTON_TOOLTIP_MESSAGE}>
                {buttonContent}
            </Tooltip>
        );
    }

    return buttonContent;
});
